import { ArrowDropDown, ArrowRight } from '@mui/icons-material';
import { Box, Collapse, List, ListItemButton } from '@mui/material';
import React, { useCallback, useMemo } from 'react';

import { Employees } from '~/data/employees/types';

import { SearchedItem } from '../SearchedItem';

import { useSxStyles } from './useStyles';

type CategorySearchItemProps = {
  header: string;
  handleClick: (id: number, unitId: number) => void;
  itemIndex: number;
  activeIndex: number;
  setActiveIndex: React.Dispatch<React.SetStateAction<number>>;
  list?: Employees[];
  showEmpNumber?: boolean;
};

export const CategorySearchItem = (props: CategorySearchItemProps) => {
  const {
    list,
    header,
    handleClick,
    itemIndex,
    activeIndex,
    setActiveIndex,
    showEmpNumber,
  } = props;

  const sxStyles = useSxStyles();
  const isOpened = useMemo(
    () => itemIndex === activeIndex,
    [activeIndex, itemIndex],
  );
  const onItemClick = useCallback(() => {
    setActiveIndex(isOpened ? -1 : itemIndex);
  }, [isOpened, itemIndex, setActiveIndex]);

  return (
    <>
      <Box sx={sxStyles.flex}>
        <ListItemButton
          sx={{ ...sxStyles.li, ...(isOpened ? sxStyles.liOpened : {}) }}
          onClick={onItemClick}
        >
          <Box component={'p'} sx={sxStyles.expandableIcon}>
            {isOpened ? <ArrowDropDown /> : <ArrowRight />}
          </Box>
          <Box component={'span'} sx={sxStyles.actionScopes}>
            {header}
          </Box>
        </ListItemButton>
      </Box>
      <Collapse in={isOpened} timeout="auto" unmountOnExit>
        <List dense>
          {list?.map((employee: Employees) => (
            <SearchedItem
              key={`${employee.fEmpPersonNumber}-${employee.fEmpId}`}
              employee={employee}
              handleClick={handleClick}
              showEmpNumber={showEmpNumber}
            />
          ))}
        </List>
      </Collapse>
    </>
  );
};
